export default function Loader({ size = "large" }) {
  const styles = {
    xs: "w-16 h-16 border-t border-b",
    small: "w-24 h-24 border-t-2 border-b-2",
    large: "w-40 h-40 border-t-4 border-b-4"
  }[size]

  const padding = {
    xs: 'py-4',
    small: 'py-8',
    large: 'py-16'
  }[size]

  return (
    <div className={`flex items-center justify-center ${padding}`}>
      <div className={`border-gray-700 rounded-full animate-spin ${styles}`}></div>
    </div>
  )
}
